
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/post/[postUid]",
      function () {
        return require("private-next-pages/blog/post/[postUid].js");
      }
    ]);
  